export default __webpack_public_path__ + "static/media/hero.4aaa25dc.png";